import React, { memo } from 'react';
import { Button, Flex, Text, ThemedImage, CalloutOutline } from 'core/components';
import kentikAiUser from 'app/assets/kentik-ai-user.svg';
import kentikAiUserDark from 'app/assets/kentik-ai-user-dark.svg';
import { MessageItem, AgentMessageBubble, MessageHeader } from '../KaizenChatSession.styles';
import StepComponent from './StepComponent';

const stepSorter = (a, b) => (a.step_number || 0) - (b.step_number || 0);

// Memoized agent message component
const AgentMessage = memo(
  ({
    turn,
    stepReasoningOpenState,
    onToggleReasoning,
    onSelectToolResult,
    onShowAgentDataInSidebar,
    formatDate,
    isCopilotMode,
    isExistingChatLoading
  }) => {
    const sortedSteps = turn.steps?.slice().sort(stepSorter);

    return (
      <MessageItem key={`agent-${turn.id}`}>
        <AgentMessageBubble>
          <MessageHeader>
            <ThemedImage src={kentikAiUser} darkSrc={kentikAiUserDark} width={24} height={24} />
            <Flex alignItems="center" gap={1}>
              <Text fontSize={13} fontWeight="bold">
                Kentik AI
              </Text>
              <Text muted fontSize={13} fontWeight="normal">
                {formatDate(turn.created_at)}
              </Text>
            </Flex>
            <Button
              small
              minimal
              icon="info-sign"
              onClick={() => onShowAgentDataInSidebar(turn, sortedSteps)}
              text="Show Data in Console"
            />
          </MessageHeader>

          {sortedSteps?.map((step, stepIndex) => {
            const stepId = step.id || stepIndex;
            const isStepReasoningOpen = stepReasoningOpenState[stepId] ?? true;

            return (
              <StepComponent
                key={`step-${stepId}`}
                step={step}
                stepIndex={stepIndex}
                isStepReasoningOpen={isStepReasoningOpen}
                onToggleReasoning={onToggleReasoning}
                onSelectToolResult={onSelectToolResult}
                isCopilotMode={isCopilotMode}
                isExistingChatLoading={isExistingChatLoading}
              />
            );
          })}

          {turn.error_message && (
            <CalloutOutline intent="danger">
              <Text small>Error: something went wrong</Text>
            </CalloutOutline>
          )}
        </AgentMessageBubble>
      </MessageItem>
    );
  }
);

AgentMessage.displayName = 'AgentMessage';

export default AgentMessage;
